// Mirrors ColorModeHelper::CLASS_MAP
const CLASS_MAP = {
  knoxLight: "base knox-light-mode",
  knoxDark: "base knox-dark-mode",
  kolide: "kolide knox-light-mode"
}

const ALL_COLOR_MODE_CLASSES = [...new Set(Object.values(CLASS_MAP).flatMap(classes => classes.split(" ")))]

const prefersDarkMode = () => window.matchMedia("(prefers-color-scheme: dark)")

const metaContent = name => document.querySelector(`meta[name="${name}"]`)?.content

const isSystemColorMode = () =>
  metaContent("current-flags-can-update-color-mode") === "true" &&
    metaContent("current-color-mode") === "system"

export const updateCurrentColorMode = () => {
  if (!isSystemColorMode()) return

  const classes = prefersDarkMode().matches ? CLASS_MAP.knoxDark : CLASS_MAP.knoxLight
  document.body.classList.remove(...ALL_COLOR_MODE_CLASSES)
  document.body.classList.add(...classes.split(" "))
}

document.addEventListener("DOMContentLoaded", () => {
  updateCurrentColorMode()
  prefersDarkMode().addEventListener("change", updateCurrentColorMode)
  document.addEventListener("turbo:load", updateCurrentColorMode)
})
